import { V as VividElement, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';

class TabPanel extends VividElement {
}

const TabPanelTemplate = html`
	<template slot="tabpanel" role="tabpanel">
		<slot></slot>
	</template>
`;

const tabPanelDefinition = defineVividComponent(
  "tab-panel",
  TabPanel,
  TabPanelTemplate,
  [],
  {}
);
const registerTabPanel = createRegisterFunction(tabPanelDefinition);

export { TabPanel as T, registerTabPanel as r, tabPanelDefinition as t };
